export const placesSkipToMainContent = "yZ6gOb";
export const placesMainContent = "stoxAd";
export default {placesSkipToMainContent,placesMainContent};